// extracted by mini-css-extract-plugin
module.exports = {"qrCode":"_3199989"};